'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { loadWelloChat, type WelloChatBootOptions, type WelloChatLayout, whenWelloChatReady } from './index';
export type WelloChatProps = WelloChatBootOptions & {
  // 상담창 서버의 loader.js 주소
  src: string;
};

// 레이아웃에 한 번 둔다. 회원 토큰이 바뀌면 다시 부팅하고, 빠지면(언마운트) 상담창을 걷어낸다
export const WelloChat = t0 => {
  const $ = _c(14);
  const {
    src,
    memberToken: t1,
    hideLauncher: t2,
    layout
  } = t0;
  const memberToken = t1 === undefined ? null : t1;
  const hideLauncher = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== layout) {
    t3 = JSON.stringify(layout ?? {});
    $[0] = layout;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const layoutKey = t3;
  let t4;
  let t5;
  if ($[2] !== layoutKey || $[3] !== src) {
    t4 = () => {
      loadWelloChat(src).then(chat => chat.setLayout?.(JSON.parse(layoutKey) as WelloChatLayout)).catch(_temp);
    };
    t5 = [src, layoutKey];
    $[2] = layoutKey;
    $[3] = src;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[6] !== hideLauncher || $[7] !== memberToken || $[8] !== src) {
    t6 = () => {
      let cancelled = false;
      loadWelloChat(src).then(chat_0 => {
        if (!cancelled) {
          chat_0.boot({
            memberToken,
            hideLauncher
          });
        }
      }).catch(_temp2);
      return () => {
        cancelled = true;
      };
    };
    t7 = [src, memberToken, hideLauncher];
    $[6] = hideLauncher;
    $[7] = memberToken;
    $[8] = src;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[11] !== src) {
    t8 = () => () => {
      loadWelloChat(src).then(_temp3).catch(_temp4);
    };
    t9 = [src];
    $[11] = src;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  useEffect(t8, t9);
  return null;
};

// 사이트의 버튼·배지에서 상담창을 다룰 때. <WelloChat>이 화면 어딘가에 있어야 동작한다
export const useWelloChat = () => {
  const $ = _c(5);
  const [unread, setUnread] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let cancelled = false;
      let offs = [];
      whenWelloChatReady().then(chat => {
        if (cancelled) {
          return;
        }
        setIsOpen(chat.isOpen());
        offs = [chat.on("unread", count => setUnread(count ?? 0)), chat.on("open", () => setIsOpen(true)), chat.on("close", () => setIsOpen(false))];
      });
      return () => {
        cancelled = true;
        offs.forEach(_temp5);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== isOpen || $[3] !== unread) {
    t2 = {
      unread,
      isOpen,
      open: _temp7,
      close: _temp9
    };
    $[2] = isOpen;
    $[3] = unread;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp() {}
function _temp2(error) {
  return reportError(error);
}
function _temp3(chat_1) {
  return chat_1.shutdown();
}
function _temp4() {}
function _temp5(off) {
  return off();
}
function _temp6(chat_0) {
  return chat_0.open();
}
function _temp7() {
  return void whenWelloChatReady().then(_temp6);
}
function _temp8(chat_1) {
  return chat_1.close();
}
function _temp9() {
  return void whenWelloChatReady().then(_temp8);
}